// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-main: #fff7fb;
  --bg-soft: #fff1f7;
  --bg-card: rgba(255, 255, 255, 0.82);
  --pink-100: #ffe4ef;
  --pink-200: #fbcfe8;
  --pink-300: #f9a8d4;
  --pink-400: #f472b6;
  --pink-500: #ec4899;
  --pink-600: #db2777;
  --rose-text: #7a284f;
  --text-dark: #2a2230;
  --text-soft: #5f4b59;
  --shadow-soft: 0 10px 30px rgba(236, 72, 153, 0.12);
  --shadow-hover: 0 18px 40px rgba(236, 72, 153, 0.2);
  --border-soft: rgba(244, 114, 182, 0.15);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: Arial, sans-serif;
  background:
    radial-gradient(circle at top left, rgba(249, 168, 212, 0.18), transparent 28%),
    radial-gradient(circle at top right, rgba(244, 114, 182, 0.12), transparent 24%),
    linear-gradient(to bottom, #fff7fb, #fff1f7 45%, #fff8fc);
  color: var(--text-dark);
}

a {
  text-decoration: none;
  color: inherit;
}

button {
  font: inherit;
}

.app {
  min-height: 100vh;
}

/* Hero */

.hero {
  position: relative;
  overflow: hidden;
  background:
    linear-gradient(135deg, rgba(249, 168, 212, 0.96), rgba(244, 114, 182, 0.96)),
    linear-gradient(135deg, #f9a8d4, #f472b6);
  color: white;
  padding: 24px 60px 100px;
  border-bottom-left-radius: 40px;
  border-bottom-right-radius: 40px;
  box-shadow: 0 12px 40px rgba(236, 72, 153, 0.18);
}

.hero::before,
.hero::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.14);
  filter: blur(2px);
}

.hero::before {
  width: 260px;
  height: 260px;
  top: -60px;
  right: -80px;
}

.hero::after {
  width: 180px;
  height: 180px;
  bottom: 10px;
  left: -50px;
}

.petals {
  position: absolute;
  font-size: 28px;
  opacity: 0.22;
  pointer-events: none;
  animation: floatPetals 9s ease-in-out infinite;
}

.petals-1 {
  top: 18%;
  left: 12%;
}

.petals-2 {
  top: 30%;
  right: 18%;
  animation-delay: 2s;
}

.petals-3 {
  top: 60%;
  left: 22%;
  animation-delay: 4s;
}

@keyframes floatPetals {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(14px) rotate(8deg);
  }
  100% {
    transform: translateY(0px) rotate(0deg);
  }
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 90px;
  position: relative;
  z-index: 2;
}

.logo {
  font-size: 1.55rem;
  font-weight: 700;
  letter-spacing: 0.4px;
}

.nav-links {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.nav-links a,
.nav-contact-btn {
  color: white;
  font-weight: 600;
  position: relative;
  transition: opacity 0.25s ease;
}

.nav-links a:hover,
.nav-contact-btn:hover {
  opacity: 0.85;
}

.nav-contact-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

.hero-content {
  max-width: 760px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 2;
}

.intro {
  color: #fff1f7;
  margin-bottom: 12px;
  font-size: 1rem;
  letter-spacing: 0.5px;
}

.hero-content h1 {
  font-size: 3.4rem;
  margin-bottom: 12px;
  line-height: 1.1;
}

.hero-content h2 {
  font-size: 2rem;
  margin-bottom: 22px;
  color: #fff5fa;
  font-weight: 600;
}

.summary {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 32px;
  color: #fff7fb;
  max-width: 680px;
  margin-left: auto;
  margin-right: auto;
}

.hero-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  padding: 13px 24px;
  border-radius: 999px;
  font-weight: 700;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
  border: none;
  cursor: pointer;
}

.btn:hover {
  transform: translateY(-2px);
}

.btn.primary {
  background: white;
  color: var(--pink-600);
}

.btn.primary:hover {
  background: #fff5fa;
}

.btn.secondary {
  background: rgba(255, 255, 255, 0.16);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.35);
  backdrop-filter: blur(6px);
}

.btn.secondary:hover {
  background: rgba(255, 255, 255, 0.24);
}

/* Main content */

.main-content {
  padding: 34px 20px 70px;
}

.section {
  max-width: 1080px;
  margin: 0 auto 32px;
  padding: 42px 28px;
  background: var(--bg-card);
  border: 1px solid var(--border-soft);
  border-radius: 28px;
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-soft);
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 22px;
}

.section-flower {
  font-size: 1.2rem;
}

.section h2 {
  text-align: center;
  color: var(--rose-text);
  font-size: 2rem;
}

.about-content {
  max-width: 820px;
  margin: 0 auto;
}

.about-content p {
  text-align: center;
  margin: 0 auto 14px;
  line-height: 1.8;
  color: var(--text-soft);
}

/* Skills */

.skills-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  justify-content: center;
  margin-top: 26px;
}

.skills-grid span {
  background: linear-gradient(135deg, #ffe4ef, #fbcfe8);
  color: #8a3059;
  padding: 12px 18px;
  border-radius: 999px;
  font-weight: 700;
  box-shadow: 0 6px 14px rgba(244, 114, 182, 0.16);
  border: 1px solid rgba(244, 114, 182, 0.14);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.skills-grid span:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 18px rgba(244, 114, 182, 0.22);
}

/* Projects */

.projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 28px;
  margin-top: 26px;
  align-items: stretch;
}

.project-card {
  background: linear-gradient(to bottom, #ffffff, #fff8fc);
  padding: 20px;
  border-radius: 22px;
  border: 1px solid rgba(244, 114, 182, 0.12);
  box-shadow: 0 8px 24px rgba(236, 72, 153, 0.1);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.project-card:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-hover);
}

.project-media {
  margin-bottom: 16px;
}

.project-image {
  width: 100%;
  height: 220px;
  object-fit: cover;
  border-radius: 16px;
  border: 1px solid rgba(244, 114, 182, 0.1);
  display: block;
}

.project-placeholder {
  background: linear-gradient(135deg, #fff0f7, #ffe4ef);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #b4537c;
  text-align: center;
  padding: 20px;
}

.placeholder-icon {
  font-size: 2rem;
  margin-bottom: 10px;
}

.placeholder-text {
  font-size: 0.95rem;
  font-weight: 700;
}

.project-body {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.project-card h3 {
  color: var(--rose-text);
  margin-bottom: 8px;
  line-height: 1.35;
}

.project-category {
  color: #b4537c;
  font-size: 0.92rem;
  margin-bottom: 12px;
  font-style: italic;
  font-weight: 600;
}

.project-description {
  margin-bottom: 12px;
  line-height: 1.7;
  color: var(--text-soft);
  flex: 1 1;
}

.tech {
  color: #7b5168;
  margin-bottom: 0;
}

.project-links {
  display: flex;
  gap: 16px;
  margin-top: 18px;
  align-items: center;
  flex-wrap: wrap;
}

.project-links a,
.screenshot-btn {
  color: var(--pink-600);
  font-weight: 700;
  transition: color 0.2s ease, transform 0.2s ease;
}

.project-links a:hover,
.screenshot-btn:hover {
  color: #9d174d;
}

.screenshot-btn {
  background: #fff0f7;
  border: 1px solid rgba(236, 72, 153, 0.18);
  padding: 10px 14px;
  border-radius: 999px;
  cursor: pointer;
}

/* Experience */

.experience-list {
  display: flex;
  flex-direction: column;
  gap: 28px;
  margin-top: 20px;
}

.experience-card {
  background: linear-gradient(to bottom, #ffffff, #fff8fc);
  border: 1px solid rgba(244, 114, 182, 0.12);
  border-radius: 22px;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(236, 72, 153, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.experience-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-hover);
}

.experience-title {
  color: var(--rose-text);
  font-size: 1.2rem;
  margin-bottom: 6px;
}

.experience-date {
  font-size: 0.85rem;
  color: #a1627a;
  margin-bottom: 8px;
  font-weight: 600;
}

.experience-subtitle {
  font-size: 0.95rem;
  font-style: italic;
  color: #b4537c;
  margin-bottom: 12px;
  font-weight: 600;
}

.experience-description {
  color: var(--text-soft);
  line-height: 1.75;
}

/* Modal shared */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(116, 35, 78, 0.35);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  position: relative;
  width: 100%;
  background: white;
  border-radius: 22px;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18);
}

.image-modal {
  max-width: 960px;
  max-height: 90vh;
  padding: 14px;
}

.image-modal img {
  width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 16px;
  display: block;
}

.contact-modal {
  max-width: 620px;
  padding: 34px 28px 28px;
  background: linear-gradient(to bottom right, #fffafd, #fff2f8);
  border: 1px solid rgba(244, 114, 182, 0.15);
}

.modal-close {
  position: absolute;
  top: -12px;
  right: -12px;
  background: white;
  color: var(--pink-600);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.15);
}

.contact-modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 18px;
}

.contact-modal-flower {
  font-size: 1.4rem;
}

.contact-modal-header h2 {
  color: var(--rose-text);
  font-size: 2rem;
}

.contact-modal-text {
  text-align: center;
  color: var(--text-soft);
  line-height: 1.8;
  margin-bottom: 24px;
}

.contact-info-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 26px;
}

.contact-info-item {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(244, 114, 182, 0.12);
  border-radius: 16px;
  padding: 16px 18px;
  box-shadow: 0 6px 16px rgba(236, 72, 153, 0.08);
}

.contact-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 700;
  color: #b4537c;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 6px;
}

.contact-info-item a {
  color: var(--pink-600);
  font-weight: 700;
  word-break: break-word;
}

.contact-info-item a:hover {
  color: #9d174d;
}

.contact-modal-actions {
  display: flex;
  gap: 14px;
  justify-content: center;
  flex-wrap: wrap;
}

.contact-action-btn {
  padding: 12px 20px;
  border-radius: 999px;
  font-weight: 700;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.contact-action-btn:hover {
  transform: translateY(-2px);
}

.primary-contact {
  background: var(--pink-500);
  color: white;
  box-shadow: 0 10px 20px rgba(236, 72, 153, 0.22);
}

.primary-contact:hover {
  background: var(--pink-600);
}

.secondary-contact {
  background: #fff0f7;
  color: var(--pink-600);
  border: 1px solid rgba(236, 72, 153, 0.18);
}

/* Responsive */

@media (max-width: 768px) {
  .hero {
    padding: 22px 20px 70px;
    border-bottom-left-radius: 28px;
    border-bottom-right-radius: 28px;
  }

  .navbar {
    flex-direction: column;
    gap: 18px;
    margin-bottom: 56px;
  }

  .nav-links {
    justify-content: center;
  }

  .hero-content h1 {
    font-size: 2.5rem;
  }

  .hero-content h2 {
    font-size: 1.5rem;
  }

  .summary {
    font-size: 1rem;
  }

  .section {
    padding: 30px 18px;
    border-radius: 22px;
  }

  .projects-grid {
    grid-template-columns: 1fr;
  }

  .project-image {
    height: 200px;
  }

  .contact-modal {
    padding: 28px 18px 22px;
  }
}

@media (max-width: 480px) {
  .hero-content h1 {
    font-size: 2.1rem;
  }

  .hero-content h2 {
    font-size: 1.25rem;
  }

  .btn {
    width: 100%;
    text-align: center;
  }

  .hero-buttons {
    flex-direction: column;
  }

  .project-links {
    flex-direction: column;
    align-items: flex-start;
  }

  .contact-modal-actions {
    flex-direction: column;
  }

  .contact-action-btn {
    width: 100%;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,mDAAmD;EACnD,mDAAmD;EACnD,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B;;;6DAG2D;EAC3D,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA,SAAS;;AAET;EACE,kBAAkB;EAClB,gBAAgB;EAChB;;6CAE2C;EAC3C,YAAY;EACZ,wBAAwB;EACxB,+BAA+B;EAC/B,gCAAgC;EAChC,gDAAgD;AAClD;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,2EAA2E;EAC3E,0CAA0C;EAC1C,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;AACvC;;AAEA,iBAAiB;;AAEjB;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gDAAgD;EAChD,2CAA2C;EAC3C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA,aAAa;;AAEb;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,wDAAwD;EACxD,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,8CAA8C;EAC9C,uDAAuD;EACvD,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,eAAe;;AAEf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;EACxD,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,8CAA8C;EAC9C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,iBAAiB;;AAEjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,8DAA8D;EAC9D,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,2EAA2E;AAC7E;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,eAAe;;AAEf;EACE;IACE,uBAAuB;IACvB,+BAA+B;IAC/B,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":[":root {\n  --bg-main: #fff7fb;\n  --bg-soft: #fff1f7;\n  --bg-card: rgba(255, 255, 255, 0.82);\n  --pink-100: #ffe4ef;\n  --pink-200: #fbcfe8;\n  --pink-300: #f9a8d4;\n  --pink-400: #f472b6;\n  --pink-500: #ec4899;\n  --pink-600: #db2777;\n  --rose-text: #7a284f;\n  --text-dark: #2a2230;\n  --text-soft: #5f4b59;\n  --shadow-soft: 0 10px 30px rgba(236, 72, 153, 0.12);\n  --shadow-hover: 0 18px 40px rgba(236, 72, 153, 0.2);\n  --border-soft: rgba(244, 114, 182, 0.15);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: Arial, sans-serif;\n  background:\n    radial-gradient(circle at top left, rgba(249, 168, 212, 0.18), transparent 28%),\n    radial-gradient(circle at top right, rgba(244, 114, 182, 0.12), transparent 24%),\n    linear-gradient(to bottom, #fff7fb, #fff1f7 45%, #fff8fc);\n  color: var(--text-dark);\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\nbutton {\n  font: inherit;\n}\n\n.app {\n  min-height: 100vh;\n}\n\n/* Hero */\n\n.hero {\n  position: relative;\n  overflow: hidden;\n  background:\n    linear-gradient(135deg, rgba(249, 168, 212, 0.96), rgba(244, 114, 182, 0.96)),\n    linear-gradient(135deg, #f9a8d4, #f472b6);\n  color: white;\n  padding: 24px 60px 100px;\n  border-bottom-left-radius: 40px;\n  border-bottom-right-radius: 40px;\n  box-shadow: 0 12px 40px rgba(236, 72, 153, 0.18);\n}\n\n.hero::before,\n.hero::after {\n  content: \"\";\n  position: absolute;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.14);\n  filter: blur(2px);\n}\n\n.hero::before {\n  width: 260px;\n  height: 260px;\n  top: -60px;\n  right: -80px;\n}\n\n.hero::after {\n  width: 180px;\n  height: 180px;\n  bottom: 10px;\n  left: -50px;\n}\n\n.petals {\n  position: absolute;\n  font-size: 28px;\n  opacity: 0.22;\n  pointer-events: none;\n  animation: floatPetals 9s ease-in-out infinite;\n}\n\n.petals-1 {\n  top: 18%;\n  left: 12%;\n}\n\n.petals-2 {\n  top: 30%;\n  right: 18%;\n  animation-delay: 2s;\n}\n\n.petals-3 {\n  top: 60%;\n  left: 22%;\n  animation-delay: 4s;\n}\n\n@keyframes floatPetals {\n  0% {\n    transform: translateY(0px) rotate(0deg);\n  }\n  50% {\n    transform: translateY(14px) rotate(8deg);\n  }\n  100% {\n    transform: translateY(0px) rotate(0deg);\n  }\n}\n\n.navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 90px;\n  position: relative;\n  z-index: 2;\n}\n\n.logo {\n  font-size: 1.55rem;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n}\n\n.nav-links {\n  display: flex;\n  gap: 24px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.nav-links a,\n.nav-contact-btn {\n  color: white;\n  font-weight: 600;\n  position: relative;\n  transition: opacity 0.25s ease;\n}\n\n.nav-links a:hover,\n.nav-contact-btn:hover {\n  opacity: 0.85;\n}\n\n.nav-contact-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n.hero-content {\n  max-width: 760px;\n  margin: 0 auto;\n  text-align: center;\n  position: relative;\n  z-index: 2;\n}\n\n.intro {\n  color: #fff1f7;\n  margin-bottom: 12px;\n  font-size: 1rem;\n  letter-spacing: 0.5px;\n}\n\n.hero-content h1 {\n  font-size: 3.4rem;\n  margin-bottom: 12px;\n  line-height: 1.1;\n}\n\n.hero-content h2 {\n  font-size: 2rem;\n  margin-bottom: 22px;\n  color: #fff5fa;\n  font-weight: 600;\n}\n\n.summary {\n  font-size: 1.1rem;\n  line-height: 1.8;\n  margin-bottom: 32px;\n  color: #fff7fb;\n  max-width: 680px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.hero-buttons {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.btn {\n  padding: 13px 24px;\n  border-radius: 999px;\n  font-weight: 700;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);\n  border: none;\n  cursor: pointer;\n}\n\n.btn:hover {\n  transform: translateY(-2px);\n}\n\n.btn.primary {\n  background: white;\n  color: var(--pink-600);\n}\n\n.btn.primary:hover {\n  background: #fff5fa;\n}\n\n.btn.secondary {\n  background: rgba(255, 255, 255, 0.16);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  backdrop-filter: blur(6px);\n}\n\n.btn.secondary:hover {\n  background: rgba(255, 255, 255, 0.24);\n}\n\n/* Main content */\n\n.main-content {\n  padding: 34px 20px 70px;\n}\n\n.section {\n  max-width: 1080px;\n  margin: 0 auto 32px;\n  padding: 42px 28px;\n  background: var(--bg-card);\n  border: 1px solid var(--border-soft);\n  border-radius: 28px;\n  backdrop-filter: blur(10px);\n  box-shadow: var(--shadow-soft);\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 22px;\n}\n\n.section-flower {\n  font-size: 1.2rem;\n}\n\n.section h2 {\n  text-align: center;\n  color: var(--rose-text);\n  font-size: 2rem;\n}\n\n.about-content {\n  max-width: 820px;\n  margin: 0 auto;\n}\n\n.about-content p {\n  text-align: center;\n  margin: 0 auto 14px;\n  line-height: 1.8;\n  color: var(--text-soft);\n}\n\n/* Skills */\n\n.skills-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  justify-content: center;\n  margin-top: 26px;\n}\n\n.skills-grid span {\n  background: linear-gradient(135deg, #ffe4ef, #fbcfe8);\n  color: #8a3059;\n  padding: 12px 18px;\n  border-radius: 999px;\n  font-weight: 700;\n  box-shadow: 0 6px 14px rgba(244, 114, 182, 0.16);\n  border: 1px solid rgba(244, 114, 182, 0.14);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.skills-grid span:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 18px rgba(244, 114, 182, 0.22);\n}\n\n/* Projects */\n\n.projects-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 28px;\n  margin-top: 26px;\n  align-items: stretch;\n}\n\n.project-card {\n  background: linear-gradient(to bottom, #ffffff, #fff8fc);\n  padding: 20px;\n  border-radius: 22px;\n  border: 1px solid rgba(244, 114, 182, 0.12);\n  box-shadow: 0 8px 24px rgba(236, 72, 153, 0.1);\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.project-card:hover {\n  transform: translateY(-6px);\n  box-shadow: var(--shadow-hover);\n}\n\n.project-media {\n  margin-bottom: 16px;\n}\n\n.project-image {\n  width: 100%;\n  height: 220px;\n  object-fit: cover;\n  border-radius: 16px;\n  border: 1px solid rgba(244, 114, 182, 0.1);\n  display: block;\n}\n\n.project-placeholder {\n  background: linear-gradient(135deg, #fff0f7, #ffe4ef);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #b4537c;\n  text-align: center;\n  padding: 20px;\n}\n\n.placeholder-icon {\n  font-size: 2rem;\n  margin-bottom: 10px;\n}\n\n.placeholder-text {\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.project-body {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.project-card h3 {\n  color: var(--rose-text);\n  margin-bottom: 8px;\n  line-height: 1.35;\n}\n\n.project-category {\n  color: #b4537c;\n  font-size: 0.92rem;\n  margin-bottom: 12px;\n  font-style: italic;\n  font-weight: 600;\n}\n\n.project-description {\n  margin-bottom: 12px;\n  line-height: 1.7;\n  color: var(--text-soft);\n  flex: 1;\n}\n\n.tech {\n  color: #7b5168;\n  margin-bottom: 0;\n}\n\n.project-links {\n  display: flex;\n  gap: 16px;\n  margin-top: 18px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.project-links a,\n.screenshot-btn {\n  color: var(--pink-600);\n  font-weight: 700;\n  transition: color 0.2s ease, transform 0.2s ease;\n}\n\n.project-links a:hover,\n.screenshot-btn:hover {\n  color: #9d174d;\n}\n\n.screenshot-btn {\n  background: #fff0f7;\n  border: 1px solid rgba(236, 72, 153, 0.18);\n  padding: 10px 14px;\n  border-radius: 999px;\n  cursor: pointer;\n}\n\n/* Experience */\n\n.experience-list {\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n  margin-top: 20px;\n}\n\n.experience-card {\n  background: linear-gradient(to bottom, #ffffff, #fff8fc);\n  border: 1px solid rgba(244, 114, 182, 0.12);\n  border-radius: 22px;\n  padding: 24px;\n  box-shadow: 0 8px 24px rgba(236, 72, 153, 0.1);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.experience-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-hover);\n}\n\n.experience-title {\n  color: var(--rose-text);\n  font-size: 1.2rem;\n  margin-bottom: 6px;\n}\n\n.experience-date {\n  font-size: 0.85rem;\n  color: #a1627a;\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.experience-subtitle {\n  font-size: 0.95rem;\n  font-style: italic;\n  color: #b4537c;\n  margin-bottom: 12px;\n  font-weight: 600;\n}\n\n.experience-description {\n  color: var(--text-soft);\n  line-height: 1.75;\n}\n\n/* Modal shared */\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(116, 35, 78, 0.35);\n  backdrop-filter: blur(8px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-content {\n  position: relative;\n  width: 100%;\n  background: white;\n  border-radius: 22px;\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18);\n}\n\n.image-modal {\n  max-width: 960px;\n  max-height: 90vh;\n  padding: 14px;\n}\n\n.image-modal img {\n  width: 100%;\n  max-height: 80vh;\n  object-fit: contain;\n  border-radius: 16px;\n  display: block;\n}\n\n.contact-modal {\n  max-width: 620px;\n  padding: 34px 28px 28px;\n  background: linear-gradient(to bottom right, #fffafd, #fff2f8);\n  border: 1px solid rgba(244, 114, 182, 0.15);\n}\n\n.modal-close {\n  position: absolute;\n  top: -12px;\n  right: -12px;\n  background: white;\n  color: var(--pink-600);\n  border: none;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  font-size: 18px;\n  font-weight: bold;\n  cursor: pointer;\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.15);\n}\n\n.contact-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.contact-modal-flower {\n  font-size: 1.4rem;\n}\n\n.contact-modal-header h2 {\n  color: var(--rose-text);\n  font-size: 2rem;\n}\n\n.contact-modal-text {\n  text-align: center;\n  color: var(--text-soft);\n  line-height: 1.8;\n  margin-bottom: 24px;\n}\n\n.contact-info-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-bottom: 26px;\n}\n\n.contact-info-item {\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(244, 114, 182, 0.12);\n  border-radius: 16px;\n  padding: 16px 18px;\n  box-shadow: 0 6px 16px rgba(236, 72, 153, 0.08);\n}\n\n.contact-label {\n  display: block;\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #b4537c;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  margin-bottom: 6px;\n}\n\n.contact-info-item a {\n  color: var(--pink-600);\n  font-weight: 700;\n  word-break: break-word;\n}\n\n.contact-info-item a:hover {\n  color: #9d174d;\n}\n\n.contact-modal-actions {\n  display: flex;\n  gap: 14px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.contact-action-btn {\n  padding: 12px 20px;\n  border-radius: 999px;\n  font-weight: 700;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n}\n\n.contact-action-btn:hover {\n  transform: translateY(-2px);\n}\n\n.primary-contact {\n  background: var(--pink-500);\n  color: white;\n  box-shadow: 0 10px 20px rgba(236, 72, 153, 0.22);\n}\n\n.primary-contact:hover {\n  background: var(--pink-600);\n}\n\n.secondary-contact {\n  background: #fff0f7;\n  color: var(--pink-600);\n  border: 1px solid rgba(236, 72, 153, 0.18);\n}\n\n/* Responsive */\n\n@media (max-width: 768px) {\n  .hero {\n    padding: 22px 20px 70px;\n    border-bottom-left-radius: 28px;\n    border-bottom-right-radius: 28px;\n  }\n\n  .navbar {\n    flex-direction: column;\n    gap: 18px;\n    margin-bottom: 56px;\n  }\n\n  .nav-links {\n    justify-content: center;\n  }\n\n  .hero-content h1 {\n    font-size: 2.5rem;\n  }\n\n  .hero-content h2 {\n    font-size: 1.5rem;\n  }\n\n  .summary {\n    font-size: 1rem;\n  }\n\n  .section {\n    padding: 30px 18px;\n    border-radius: 22px;\n  }\n\n  .projects-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .project-image {\n    height: 200px;\n  }\n\n  .contact-modal {\n    padding: 28px 18px 22px;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-content h1 {\n    font-size: 2.1rem;\n  }\n\n  .hero-content h2 {\n    font-size: 1.25rem;\n  }\n\n  .btn {\n    width: 100%;\n    text-align: center;\n  }\n\n  .hero-buttons {\n    flex-direction: column;\n  }\n\n  .project-links {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .contact-modal-actions {\n    flex-direction: column;\n  }\n\n  .contact-action-btn {\n    width: 100%;\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
